// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"sL-z","carouselContainer":"tL-z"};